import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

/**
 * The line at the foot of every screen that says which database this is.
 *
 * Until 29 September 2026 it was a fixed sentence — "staging databáze,
 * anonymizovaná kopie" — and on that day the same build went live on
 * dashboard.smileparking.cz reading the real hosted database through the
 * bridge, where the sentence was false. The question staff must never have
 * to guess is whether the telephone number in front of them belongs to a
 * real customer, so the footer now asks the server: production reads
 * through the bridge and is read-only (the writes stay in the old extranet
 * during the parallel run); anything else is a copy where the writes exist.
 */
const WRITES =
  'Zápisy: Nová rezervace, Změnit termín, Přijel, Odjel, Účtenka, Nepřijel, Zrušit, Přidělit převoz, ' +
  'Služba hotová, Opravit údaje, předplacené, Interní zprávy, Uzavřít směnu a Nastavení (kapacity, uzavírky, služby).';

export function Footer() {
  const { data } = useQuery({ queryKey: ['health'], queryFn: () => api.health(), staleTime: 5 * 60_000, retry: false });
  if (!data) return <div className="footer">…</div>;
  if (data.transport === 'bridge') {
    return (
      <div className="footer">
        {data.readOnly
          ? 'Souběžný provoz · ostrá databáze, jen pro čtení. Zápisy se zatím dělají ve starém extranetu.'
          : 'Souběžný provoz · ostrá databáze, zápisy zapnuté. Každý zápis je hned vidět i ve starém extranetu.'}
      </div>
    );
  }
  return <div className="footer">Staging databáze, anonymizovaná kopie. {WRITES}</div>;
}
